import { render, staticRenderFns } from "./PropostaList.vue?vue&type=template&id=22846002"
import script from "./PropostaList.vue?vue&type=script&lang=js"
export * from "./PropostaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports